<template>
  <div class="plans">
    <div class="plans__hero">
      <div class="plans__hero-inner container">
        <plans-hero />
      </div>
      <responsive-image image-url="bg/road" alt="Internet Plans Via Zeronet" class="plans__hero-background" />
    </div>
    <div id="plans" class="plans__inner">
      <client-only>
        <plans-broadband no-hyper promo="signup">
          <template #afterPlans>
            <div class="plans__hyperfibre-cta">
              <ui-button tag="app-link" class="is-light" to="/hyperfibre">View Hyperfibre Plans Here</ui-button>
            </div>
          </template>
        </plans-broadband>
      </client-only>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { definePageMeta, useJsonld } from '#imports';
import PlansBroadband from '@/components/local/plans/PlansBroadband.vue';
import { useProducts } from '~/stores/products';
import PlansHero from '~/components/local/heros/PlansHero.vue';
import UiButton from '~/components/global/ui/UiButton.vue';
import ResponsiveImage from '~/components/global/ui/ResponsiveImage.vue';

const products = useProducts();

definePageMeta({
  key: (route) => route.fullPath,
  pageTitle: 'Sustainable Internet Plans',
  pageDescription: 'Zeronet has unlimited data Fibre internet plans to suit every household. Select your plan here and sign up today.',
});

useJsonld(() => {
  return products.plans.map((product) => {
    return {
      '@context': 'https://schema.org',
      '@type': 'Product',
      name: product.name,
      description: `${product.speed.download} down, ${product.speed.upload} up, Fibre Internet`,
      brand: 'Zeronet',
      image: 'https://www.zeronet.co.nz',
      aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue: '5',
        ratingCount: '3',
      },
    };
  });
});
</script>

<style lang="scss">
.plans {
  position: relative;
  min-height: 100%;
  overflow: hidden;
  display: grid;
  grid-template-columns: minmax(0, 100%);

  &__inner {
    background: var(--primary);
    padding: var(--container-spacing);
    min-height: rem(600);

    @include desktop {
      padding: rem(60) var(--container-spacing);
    }
  }

  &__hero {
    position: relative;
    overflow: hidden;

    &-background {
      @include cover($z-index: -1);

      * {
        @include cover();
      }
    }

    &-inner {
      padding: calc-clamp($mobile, $fullhd, 20, 100) 0 calc-clamp($mobile, $fullhd, 30, 100);
    }
  }

  &__hyperfibre-cta {
    display: flex;
    justify-content: center;
  }
}
</style>
